import { NameSpacing } from '../../../NonReact/utils/NameSpacing'

// The available tabs.
enum TabNamespaces {
    DETAILS = 'details',
    ADVANCED = 'advanced',
    OMNICHANNEL = 'omnichannel'
}

// Details tab fields.
enum DetailsTabFieldNames {
    GUID = 'guid',
    AGENT_NUMBER = 'agentNumber',
    PARTITION = 'partition',
    DESCRIPTION = 'description',
    UPDATE_ITEMS = 'updateItems'
}

// Advanced tab fields.
enum AdvancedTabFieldNames {
    CALL_CENTRE_LICENCE_TYPE = 'callCentreLicenceType',
    INTERNAL_NUMBER = 'internalNumber',
    CISCO_COMMON_ID = 'ciscoCommonID',
    OVERRIDE_MONITORING = 'overrideMonitoring',
    WEBEX_CALLING_USER_ID = 'webexCallingUserID',
    TEAMS_USER_ID = 'teamsUserID',
    USER_PRINCIPAL_NAME = 'userPrincipalName',
    BROADWORKS_USER_ID = 'broadworksUserID',
    OID_ON_TEL_SERVER = 'oidOnTelServer',
    OWNING_DEPARTMENT = 'owningDepartment',
    OWNING_GROUP_ID = 'owningGroupID'
}

// Omnichannel tab fields.
enum OmnichannelTabFieldNames {
    ALLOW_CONCURRENT_CHANNELS = 'allowConcurrentChannels',
    EMAIL = 'email',
    EMAIL_INTEGRATION_TYPE = 'emailIntegrationType',
    EMAIL_ADDRESS = 'emailAddress',
    EMAIL_ID_ON_EMAIL_SYSTEM = 'emailIDOnEmailSystem',
    CHAT = 'chat',
    CHAT_INTEGRATION_TYPE = 'chatIntegrationType',
    CHAT_ID_ON_CHAT_SYSTEM = 'chatIDOnChatSystem'
}

const detailsNamespacing = (fieldName: DetailsTabFieldNames): string => NameSpacing(TabNamespaces.DETAILS, fieldName)
const advancedNamespacing = (fieldName: AdvancedTabFieldNames): string => NameSpacing(TabNamespaces.ADVANCED, fieldName)
const omnichannelNamespacing = (fieldName: OmnichannelTabFieldNames): string =>
    NameSpacing(TabNamespaces.OMNICHANNEL, fieldName)
const chatNamespacing = (fieldName: OmnichannelTabFieldNames): string =>
    NameSpacing(omnichannelNamespacing(OmnichannelTabFieldNames.CHAT), fieldName)
const emailNamespacing = (fieldName: OmnichannelTabFieldNames): string =>
    NameSpacing(omnichannelNamespacing(OmnichannelTabFieldNames.EMAIL), fieldName)

// Details tab field names.
export const GUID_FIELD_NAME: string = detailsNamespacing(DetailsTabFieldNames.GUID)
export const AGENT_NUMBER_FIELD_NAME: string = detailsNamespacing(DetailsTabFieldNames.AGENT_NUMBER)
export const PARTITION_FIELD_NAME: string = detailsNamespacing(DetailsTabFieldNames.PARTITION)
export const DESCRIPTION_FIELD_NAME: string = detailsNamespacing(DetailsTabFieldNames.DESCRIPTION)
export const UPDATE_ITEMS_FIELD_NAME: string = detailsNamespacing(DetailsTabFieldNames.UPDATE_ITEMS)

// Advanced tab field names.
export const CALL_CENTRE_LICENCE_TYPE_FIELD_NAME: string = advancedNamespacing(
    AdvancedTabFieldNames.CALL_CENTRE_LICENCE_TYPE
)
export const INTERNAL_NUMBER_FIELD_NAME: string = advancedNamespacing(AdvancedTabFieldNames.INTERNAL_NUMBER)
export const CISCO_COMMON_ID_FIELD_NAME: string = advancedNamespacing(AdvancedTabFieldNames.CISCO_COMMON_ID)
export const OVERRIDE_MONITORING_FIELD_NAME: string = advancedNamespacing(AdvancedTabFieldNames.OVERRIDE_MONITORING)
export const WEBEX_CALLING_USER_ID_FIELD_NAME: string = advancedNamespacing(AdvancedTabFieldNames.WEBEX_CALLING_USER_ID)
export const BROADWORKS_USER_ID_FIELD_NAME: string = advancedNamespacing(AdvancedTabFieldNames.BROADWORKS_USER_ID)
export const TEAMS_USER_ID_FIELD_NAME: string = advancedNamespacing(AdvancedTabFieldNames.TEAMS_USER_ID)
export const USER_PRINCIPAL_NAME_FIELD_NAME: string = advancedNamespacing(AdvancedTabFieldNames.USER_PRINCIPAL_NAME)
export const OID_ON_TEL_SERVER_FIELD_NAME: string = advancedNamespacing(AdvancedTabFieldNames.OID_ON_TEL_SERVER)
export const OWNING_DEPARTMENT_FIELD_NAME: string = advancedNamespacing(AdvancedTabFieldNames.OWNING_DEPARTMENT)
export const OWNING_GROUP_ID_FIELD_NAME: string = advancedNamespacing(AdvancedTabFieldNames.OWNING_GROUP_ID)

// Omnichannel tab field names.
export const ALLOW_CONCURRENT_CHANNELS_FIELD_NAME: string = omnichannelNamespacing(
    OmnichannelTabFieldNames.ALLOW_CONCURRENT_CHANNELS
)
export const CHAT_INTEGRATION_TYPE_FIELD_NAME: string = chatNamespacing(OmnichannelTabFieldNames.CHAT_INTEGRATION_TYPE)
export const CHAT_ID_ON_CHAT_SYSTEM_FIELD_NAME: string = chatNamespacing(
    OmnichannelTabFieldNames.CHAT_ID_ON_CHAT_SYSTEM
)
export const EMAIL_INTEGRATION_TYPE_FIELD_NAME: string = emailNamespacing(
    OmnichannelTabFieldNames.EMAIL_INTEGRATION_TYPE
)
export const EMAIL_ADDRESS_FIELD_NAME: string = emailNamespacing(OmnichannelTabFieldNames.EMAIL_ADDRESS)
export const EMAIL_ID_ON_EMAIL_SYSTEM_FIELD_NAME: string = emailNamespacing(
    OmnichannelTabFieldNames.EMAIL_ID_ON_EMAIL_SYSTEM
)
